import type { PaginationMetadata, PaginationQuery } from './common'
import type { ProductCategory } from './product'

// Indonesia's three zones (no DST). Document numbers and scheduled reminders follow the workspace's.
export const WORKSPACE_TIMEZONES = ['Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'] as const
export type WorkspaceTimezone = (typeof WORKSPACE_TIMEZONES)[number]
export const WORKSPACE_TIMEZONE_LABELS: Record<WorkspaceTimezone, string> = {
  'Asia/Jakarta': 'WIB (UTC+7)',
  'Asia/Makassar': 'WITA (UTC+8)',
  'Asia/Jayapura': 'WIT (UTC+9)',
}

export interface Workspace {
  id: string
  name: string
  slug: string
  isMain: boolean
  isActive: boolean
  riderDailyWageRate: number
  timezone: WorkspaceTimezone
  createdAt: string
  updatedAt: string
}

export interface CreateWorkspaceReq {
  name: string
  slug: string
  timezone?: WorkspaceTimezone
  copyMasterFromWorkspaceId?: string
}

export interface UpdateWorkspaceReq {
  name?: string
  slug?: string
  isActive?: boolean
  riderDailyWageRate?: number
  timezone?: WorkspaceTimezone
}

export interface GetWorkspaceReq {
  q?: string
  isActive?: boolean
  pagination?: PaginationQuery
}

export interface WorkspaceList {
  items: Workspace[]
  pagination: PaginationMetadata
}

export interface WorkspaceBranding {
  name: string
}

export interface CategoryBonusRule {
  id: string
  workspaceId: string
  category: ProductCategory
  /** Set -> this rule overrides the category rule for this one product. */
  productId: string | null
  thresholdQty: number
  ratePerUnit: number
  /** Flat per-unit rider sales commission, no threshold gate. */
  baseRatePerUnit: number
  createdAt: string
  updatedAt: string
}

export interface UpsertCategoryBonusRuleReq {
  category: ProductCategory
  productId?: string | null
  thresholdQty: number
  ratePerUnit: number
  baseRatePerUnit: number
}


